import React, { useState } from 'react';
import { Table } from 'rsuite';
import { ActionCell, LinkCell, ImageLinkCell } from './CustomCells';
import CustomHeaderCell from '../../widgets/custom-cell/HeaderCell';

const { Column, HeaderCell, Cell } = Table;

export default function StorageDeviceList() {
  const [sort, setSort] = useState({ column: 'quantity', type: 'asc' });

  const handleSortColumn = (column, type) => {
    setSort({ column, type });
  };

  return (
    <Table
      bordered
      cellBordered
      sortColumn={sort.column}
      sortType={sort.type}
      onSortColumn={handleSortColumn}
    >
      <Column sortable width={60}>
        <CustomHeaderCell>ID</CustomHeaderCell>
        <Cell dataKey="quantity" />
      </Column>
      <Column width={70} align="center">
        <CustomHeaderCell>Photo</CustomHeaderCell>
        <ImageLinkCell dataKey="" />
      </Column>
      <Column sortable flexGrow={1}>
        <CustomHeaderCell>Name</CustomHeaderCell>
        <LinkCell dataKey="" />
      </Column>
      <Column width={100} sortable resizable>
        <CustomHeaderCell>Description</CustomHeaderCell>
        <Cell dataKey="" />
      </Column>
      <Column width={100} sortable align="center">
        <CustomHeaderCell>Unit Detail</CustomHeaderCell>
        <Cell dataKey="" />
      </Column>
      <Column width={65} sortable align="center">
        <CustomHeaderCell>AR</CustomHeaderCell>
        <Cell dataKey="" />
      </Column>
      <Column width={110} sortable align="center">
        <CustomHeaderCell>Date Created</CustomHeaderCell>
        <Cell dataKey="" />
      </Column>
      <Column width={150} align="center">
        <HeaderCell>Action</HeaderCell>
        <ActionCell dataKey="" />
      </Column>
    </Table>
  );
}
